module.exports = __webpack_public_path__ + "media/images/icons/check-9c47ec9420ae9f41bf810a72ca21d741.svg";